import {
  List,
  Datagrid,
  FunctionField,
  TextInput,
  SelectInput,
  RaRecord,
} from 'react-admin';
import { DateTimeField } from '../shared/DateFields';
import { Chip } from '@mui/material';
import { useFeature } from '../admin/featureFlags/FeatureGate';
import {
  FEATURE_TMS_EXPORT_ONE_STEP,
  ORDER_SOURCES,
  VIA_WRITE_STATUSES,
  orderSourceLabel,
  viaWriteStatusColor,
  viaWriteStateName,
} from '../shared/status';
import { companyLabel } from '../shared/Panel';
import { wallClockDateTime } from '../shared/clientTime';
import {
  ClampedText,
  CompanyChip,
  compactDatagridSx,
} from '../shared/listCells';

// Nazwy „wysłane / zapisane w TMS” (paczka p. Mariusza 21.10, BR-ADM-10;
// przełącznik `tmsExportOneStep`) — kody filtra bez zmian.
const viaChoices = (tmsNames: boolean) =>
  VIA_WRITE_STATUSES.map((id) => ({ id, name: viaWriteStateName(id, tmsNames) }));
const sourceChoices = ORDER_SOURCES.map((id) => ({ id, name: orderSourceLabel(id) }));

export const ViaWriteChip = ({ record }: { record: RaRecord }) => {
  const tmsNames = useFeature(FEATURE_TMS_EXPORT_ONE_STEP);
  const s = record.viaWriteStatus as string;
  return <Chip size="small" color={viaWriteStatusColor(s)} label={viaWriteStateName(s, tmsNames)} />;
};

const listFilters = (tmsNames: boolean) => [
  <TextInput source="q" label="Nr, klient, relacja" alwaysOn />,
  <SelectInput source="viaWriteStatus" label="Stan zapisu VIA" choices={viaChoices(tmsNames)} />,
  <SelectInput source="source" label="Źródło" choices={sourceChoices} />,
];

// Bank zleceń (K5) — wspólny rejestr zleceń z toru mailowego (W3→W10) i z VIA (W11).
export const OrderList = () => {
  const tmsNames = useFeature(FEATURE_TMS_EXPORT_ONE_STEP);
  return (
  <List filters={listFilters(tmsNames)} sort={{ field: 'createdAt', order: 'DESC' }} perPage={25}>
    {/* Długie teksty skracane z podpowiedzią, spółka jako znacznik z krajem,
        czas bez sekund — wiersz w jednej linii od 1366 px (28.09.2026). */}
    <Datagrid rowClick="show" bulkActionButtons={false} sx={compactDatagridSx}>
      <FunctionField
        label="Nr zlecenia"
        render={(r: RaRecord) => <ClampedText text={r.orderNumber ?? `#${r.id}`} maxWidth={{ xs: 170, xl: 240 }} />}
      />
      <FunctionField label="Klient" render={(r: RaRecord) => <ClampedText text={r.clientName} maxWidth={{ xs: 180, xl: 280 }} />} />
      <FunctionField label="Relacja" render={(r: RaRecord) => <ClampedText text={r.relation} maxWidth={{ xs: 200, xl: 320 }} />} />
      {/* Czas polski z zapisu, nie strefa przeglądarki (`shared/clientTime.ts`). */}
      <FunctionField
        label="Załadunek"
        sortBy="loadingDate"
        render={(r: RaRecord) => <span style={{ whiteSpace: 'nowrap' }}>{wallClockDateTime(r.loadingDate)}</span>}
      />
      <FunctionField label="Stan zapisu VIA" render={(r: RaRecord) => <ViaWriteChip record={r} />} />
      <FunctionField label="Rekordy TMS" render={(r: RaRecord) => (r._count?.viaWrites ?? 0)} />
      <FunctionField
        label="Spółka"
        render={(r: RaRecord) => (
          <CompanyChip
            name={r.company?.name ?? companyLabel(r.company?.viaCompanyId ?? undefined)}
            country={r.company?.country}
          />
        )}
      />
      <DateTimeField source="createdAt" label="Utworzono" />
    </Datagrid>
  </List>
  );
};
